import * as React from 'react';
import { Dropdown, IDropdownOption, IComboBoxOption } from '@fluentui/react';
import { toggleAllMulti, withAllFirst, POOL_ALL_KEY } from '../../helpers/PoolSelectionHelper';

type Props = {
  poolOptions: IComboBoxOption[];      
  value: (string | number)[];          
  onChange: (next: (string | number)[]) => void;
  disabled?: boolean;
  label?: string;
  'data-testid'?: string;
};

export default function PoolDropdown({
  poolOptions,
  value,
  onChange,
  disabled,
  label = 'Pools',
  ...rest
}: Props) {
  const options = React.useMemo(() => withAllFirst(poolOptions), [poolOptions]);

  const handleChange = (_e: any, option?: IDropdownOption) => {
    if (!option) return;
    const next = toggleAllMulti(option as unknown as IComboBoxOption, value, options);
    onChange(next);
  };

  return (
    <Dropdown
      {...rest}
      label={label}
      data-is-focusable
      options={options as unknown as IDropdownOption[]}
      selectedKeys={value as any}
      disabled={!!disabled}
      multiSelect
      onChange={handleChange}
      onRenderTitle={(items) => {
        if (!items || items.length === 0) return null;
        const display = items
          .filter(i => String(i.key) !== String(POOL_ALL_KEY)) 
          .map(i => i.text)
          .join(', ');
        return <span>{display}</span>;
      }}
      calloutProps={{ calloutMaxHeight: 270 }}
    />
  );
}
